export default __webpack_public_path__ + "static/media/Nudi.72a06e41.jpg";